
import FieldTables from './FieldTables.js';
import RecordFilters from './RecordFilters.js';

export default [
	FieldTables,
	RecordFilters
];
